<template>
    <div class="pa-6" style="background-color: #F4F7FE; min-height: 100vh;">
        <v-progress-linear :active="cargando" :indeterminate="cargando" absolute top color="#4318FF"></v-progress-linear>
        
        <div class="text-center mb-8">
            <v-icon size="64" color="#4318FF">mdi-account-plus-outline</v-icon>
            <h1 class="text-h4 font-weight-black" style="color: #1B2559;">Registrar Usuario</h1>
            <p class="grey--text">Cree una nueva cuenta para el equipo de LIVE FIT</p>
        </div>

        <form-usuario :usuario="usuario" @guardado="onGuardar"/>

        <v-snackbar v-model="mostrarMensaje" :timeout="3000" :color="mensaje.color" top rounded="pill">
            {{ mensaje.texto }}
        </v-snackbar>
    </div>
</template>

<script>
import HttpService from '../../Servicios/HttpService'
import FormUsuario from './FormUsuario.vue'

export default {
    components: { FormUsuario },
    data:() => ({
        cargando: false,
        usuario: { usuario: "", nombre: "", dni: "", telefono: "", correo: "", rol: "2" },
        mostrarMensaje: false, 
        mensaje: { texto: "", color: "" },
    }),
    methods: {
        onGuardar(payload) {
            this.cargando = true;
            const fd = new FormData();
            fd.append("metodo", "registrar");
            fd.append("idSolicitante", localStorage.getItem("idUsuario"));
            
            fd.append("usuario_data", JSON.stringify(payload.datos));

           
            if (payload.foto) {
                fd.append("foto", payload.foto);
            }

            HttpService.registrar(fd, "usuarios.php")
            .then(res => {
                this.cargando = false;
                if(res === true || (res && res.resultado !== false)){
                    this.mensaje = { texto: "¡Registro exitoso!", color: "success" };
                    this.mostrarMensaje = true;
                    setTimeout(() => this.$router.push({ name: 'Usuarios' }), 1500);
                } else {
                    alert("Error: " + (res.mensaje || res.error || "No se pudo registrar"));
                }
            })
            .catch(() => {
                this.cargando = false;
                alert("Error de conexión con el servidor local");
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Usuarios/NuevoUsuario.vue